var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssignment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.8333 14.4997H71.63C69.6 8.89301 64.2833 4.83301 58 4.83301C51.7167 4.83301 46.4 8.89301 44.37 14.4997H24.1667C18.85 14.4997 14.5 18.8497 14.5 24.1663V91.833C14.5 97.1497 18.85 101.5 24.1667 101.5H91.8333C97.15 101.5 101.5 97.1497 101.5 91.833V24.1663C101.5 18.8497 97.15 14.4997 91.8333 14.4997ZM58 14.4997C60.6583 14.4997 62.8333 16.6747 62.8333 19.333C62.8333 21.9913 60.6583 24.1663 58 24.1663C55.3417 24.1663 53.1667 21.9913 53.1667 19.333C53.1667 16.6747 55.3417 14.4997 58 14.4997ZM67.6667 82.1663H33.8333V72.4997H67.6667V82.1663ZM82.1667 62.833H33.8333V53.1663H82.1667V62.833ZM82.1667 43.4997H33.8333V33.833H82.1667V43.4997Z",
    fill: "#BAC9D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/Assignment.94a92b03.svg";
export { ForwardRef as ReactComponent };